import { render, staticRenderFns } from "./ResourcesView.vue?vue&type=template&id=178dea4e&scoped=true"
import script from "./ResourcesView.vue?vue&type=script&lang=js"
export * from "./ResourcesView.vue?vue&type=script&lang=js"
import style0 from "./ResourcesView.vue?vue&type=style&index=0&id=178dea4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178dea4e",
  null
  
)

export default component.exports